import React from "react";

export default function LossItem({ children, className = "" }) {
  return (
    <div
      className={`flex gap-3 items-start text-[15px] leading-[1.5] text-text-body ${className}`}
    >
      <span className="flex-none w-5 h-5 rounded-full bg-status-danger-bg text-status-danger-text flex items-center justify-center text-[13px] font-bold">
        ×
      </span>
      <span>{children}</span>
    </div>
  );
}
